import React, { useEffect, useState } from "react"
import { useRecoilValue } from "recoil"
import { useTranslation } from "react-i18next"
import { isManagerWithLocationSelector, locationsSelector } from "@/atoms/userAtom"
import { Button, Space } from "antd"
import { DraftOrder } from "@/types/draftOrder.types"
import { pickupValidation } from "../../../helpers"
import { DownOutlined } from "@ant-design/icons"
import { PickupDetailsType } from "@/types/createSingleOrder.types"
import { StopType } from "@/types/orders.types"
import DisplayCellSender from "./components/DisplayCellSender"
import PickupSelectPopover from "./components/PickupSelectPopover"

interface DraftPickupCell {
  record?: DraftOrder
  onSelect?: (locationId?: string, orderId?: string) => Promise<void>
  label?: string
  defaultLocationId?: string
}

const DraftPickupCell: React.FC<DraftPickupCell> = ({
  record,
  onSelect,
  label,
  defaultLocationId,
}) => {
  const { t } = useTranslation("common")
  const stores = useRecoilValue(locationsSelector)
  const { id, sender } = record || {}
  const [isManagerWithLocation, _] = useRecoilValue(isManagerWithLocationSelector)
  const [selectedStore, setSelectedStore] = useState<PickupDetailsType | undefined>()

  useEffect(() => {
    if (defaultLocationId) {
      setSelectedStore(stores?.find((store) => defaultLocationId === store.id) as PickupDetailsType)
    }
  }, [defaultLocationId, stores])

  const pickupErrors = pickupValidation(t, sender)

  return (
    <>
      <PickupSelectPopover
        onSelect={onSelect}
        id={id}
        sender={sender}
        setSelectedStore={setSelectedStore}
      >
        <>
          {!sender && !selectedStore && (
            <Button size="middle" className="w-fit" disabled={isManagerWithLocation}>
              <Space>
                <p className="whitespace-nowrap text-sm">
                  {label ? label : t("new-orders.BatchSelectors.selectPickupStart")}
                </p>
                <DownOutlined style={{ fontSize: 12 }} />
              </Space>
            </Button>
          )}
          {sender && (
            <DisplayCellSender
              isEditable={!isManagerWithLocation}
              sender={sender}
              pickupErrors={pickupErrors}
            />
          )}
          {!sender && selectedStore && (
            <DisplayCellSender
              isEditable={!isManagerWithLocation}
              sender={{
                id: selectedStore.id,
                type: StopType.PICKUP,
                location: selectedStore,
                address: selectedStore?.address,
                buildingNumber: selectedStore?.buildingNumber,
                phone: selectedStore?.phone,
                firstName: selectedStore?.name,
                lastName: selectedStore?.alias,
              }}
            />
          )}
        </>
      </PickupSelectPopover>
    </>
  )
}

export default DraftPickupCell
